import apiClient from "../../services/api";

export const getRamais = ({ filter, token }) => {
  let options = {
    params: filter,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return apiClient.get("/extensions/", options);
};
